import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const ROW_DEFINITIONS = [
  { id: 'monthlyBenefit', label: 'Monthly Benefit', defaultVisible: true },
  { id: 'totalBenefit', label: 'Total Benefit', defaultVisible: true },
  { id: 'growth', label: 'Growth', defaultVisible: true },
  { id: 'eliminationPeriod', label: 'Elimination Period', defaultVisible: true },
  { id: 'policyType', label: 'Policy Type', defaultVisible: true },
  { id: 'methodBenefitsPaid', label: 'Method Benefits Paid', defaultVisible: true },
  { id: 'irr', label: 'IRR for Modeled LTC Event', defaultVisible: true },
  { id: 'premiumGuarantee', label: 'Are premium amounts guaranteed?', defaultVisible: true },
] as const;

export type ComparisonRowId = (typeof ROW_DEFINITIONS)[number]['id'];

export type RowVisibility = Record<ComparisonRowId, boolean>;

interface RowVisibilityState {
  visibleRows: RowVisibility;
  toggleRow: (id: ComparisonRowId) => void;
}

const defaultVisibility = Object.fromEntries(
  ROW_DEFINITIONS.map(row => [row.id, row.defaultVisible]),
) as RowVisibility;

export const useRowVisibilityStore = create<RowVisibilityState>()(
  persist(
    set => ({
      visibleRows: { ...defaultVisibility },
      toggleRow: id =>
        set(state => ({
          visibleRows: { ...state.visibleRows, [id]: !state.visibleRows[id] },
        })),
    }),
    {
      name: 'policies-comparison-row-visibility',
      partialize: state => ({ visibleRows: state.visibleRows }),
    },
  ),
);

export { ROW_DEFINITIONS };
